import { useEffect, useState } from "react";
import { ImCheckboxChecked, ImCheckboxUnchecked } from "react-icons/im";

import "./GenericCheckboxField.css";
import { useFormikContext, getIn } from "formik";

type Props = {
  name: string;
  label: string;
  labels?: {
    confirmed: string;
    notConfirmed: string;
  }
  // eslint-disable-next-line @typescript-eslint/ban-types
  onChange: Function;
  className?: string;
};

export const GenericCheckboxField = (props: Props) => {
  const { setFieldValue, values } = useFormikContext();
  const initialValueFromFormik = getIn(values, props.name);

  const [checked, setChecked] = useState(initialValueFromFormik === true);
  const [broken, setBroken] = useState(initialValueFromFormik === false);

  useEffect(() => {
    const formikValue = getIn(values, props.name);

    if (formikValue !== undefined) {
      setChecked(formikValue === true);
      setBroken(formikValue === false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValueFromFormik]);

  return (
    <div className="containerPartsEvaluation">
      <p className="font-semibold w-full">{props.label}</p>
      <label
        htmlFor={props.name}
        className="block text-sm font-medium text-gray-600"
      >
        <div className="containerPartsEvaluation-checkboxs">
          <div
            className="flex gap-2 items-center justify-start text-greenPrimary"
            onClick={() => {
              if (checked) {
                return;
              }
              setFieldValue(props.name, !checked);
              if (broken) {
                setBroken(!broken);
                setChecked(!checked);
                return;
              }
              setChecked(!checked);
              props.onChange();
            }}
          >
            {checked ? <ImCheckboxChecked /> : <ImCheckboxUnchecked />}
            <span>{props.labels?.confirmed || "Confirmado"}</span>
          </div>
          <div
            className="flex gap-2 items-center justify-start text-redPrimary"
            onClick={() => {
              if (broken) {
                return;
              }
              setFieldValue(props.name, false);
              if (checked) {
                setBroken(!broken);
                setChecked(!checked);
                return;
              }
              setBroken(!broken);
              props.onChange();
            }}
          >
            {broken ? <ImCheckboxChecked /> : <ImCheckboxUnchecked />}
            <span>{props.labels?.notConfirmed || "Não Confirmado"}</span>
          </div>
        </div>
      </label>
    </div>
  );
};
